// extracted by mini-css-extract-plugin
export default {"container":"StudyTests_container__oMUJO","page":"StudyTests_page__JqtoH","content":"StudyTests_content__xRo08","list":"StudyTests_list__ekNQK"};